// extracted by mini-css-extract-plugin
export default {"container":"App_container__VFjWQ","title":"App_title__3ntTV"};